import { z } from "zod";
import type {
    ColorVariationSet} from "./color-variation";
import {
    colorVariationSetZodSchema,
} from "./color-variation";

type Color = {
    _type: "COLOR";
    asString: string;
    withAlpha: (alpha: number) => Color;
} & ColorVariationSet;

const colorZodSchema: z.ZodSchema<Color> = z.intersection(
    z.object({
        _type: z.literal("COLOR"),
        asString: z.string(),
        withAlpha: z.lazy(() =>
            z.function().args(z.number().min(0).max(1)).returns(colorZodSchema),
        ),
    }),
    colorVariationSetZodSchema,
);

export { colorZodSchema };
export type { Color };
